<template class="acomodar">
  <div class="container-fluid py-3 px-2 px-md-4">
    <div>
      <button class="btn btn-danger ms-2 mt-2 my-2" @click="retroceder">
        <i class="bi bi-skip-backward"></i>
      </button>

      <div v-if="permisoVisualizador == 11" class="border border-1 border-dark pt-2 pb-1 mt-2 ms-2 me-2">
        <p class="tituloColorMas mb-0 ms-2 mt-2">POLITICA DE LA EMPRESA</p>
        <p class="text-secondary mb-0 ms-2 mt-0">LECTURA OBLIGATORIA</p>
      </div>
      <div v-if="permisoVisualizador == 11" class="border border-1 pb-1 mt-2 ms-2 me-2">
        <div class="px-2" v-if="solPosEstado == true && solPosMotivo == '010'">
          <strong class="tamaño">Los siguientes documentos son de lectura obligatoria para culminar
            con el proceso de selección:</strong>

          <div class="mt-2" v-for="(reglamento, index) in Reglamentos" :key="index.id">
            <div class="d-flex"> 
              <button :class="{
                'btn btn-danger   text-center':
                  Reglamentos[index][`politicas${index + 1}`],
                'btn btn-secondary align-self-center  text-center':
                  !Reglamentos[index][`politicas${index + 1}`],
              }" @click="showModales(index)">
                <img src="../../../../assets/svg/pdf.svg" alt="" />
              </button>
              <strong class="mt-1 align-self-center ms-3 tamaño">{{ index + 1 }}.</strong>

              <p class="mb-0 mt-1 align-self-center tamaño">
                {{
                  Reglamentos[index][`rutaReglamento${index + 1}`]
                    .slice(
                      48,
                      Reglamentos[index][`rutaReglamento${index + 1}`].length - 4
                    )
                    .replace(/_/g, " ")
                }}
              </p>
            </div>
          </div>

          <b-modal v-model="showModal" size="xl" modal-class="custom-modal-body" title="Visualización PDF" hide-footer
            ok-only>
            <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
            <div class="d-flex">
              <!-- <b-form-checkbox
            v-if="!d"
            class="mt-4"
            v-model="d"
          >
            <p class="mx-2">marcar aqui </p>
          </b-form-checkbox> -->
              <b-form-checkbox v-if="permisoVisualizador == 11" v-model="readCheckbox" class="mt-4">
                <p v-if="permisoVisualizador == 11" class="mx-2">
                  SI, he leído y presto mi consentimiento además de la aceptación
                  de la presente política y lo dispuesto por mi empleador.
                </p>
              </b-form-checkbox>
              <b-button v-if="permisoVisualizador == 11" class="ms-2 mt-3" :disabled="!readCheckbox"
                @click="confirmRead" variant="success"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                  fill="currentColor" class="bi bi-save2 mx-2" viewBox="0 0 16 16">
                  <path
                    d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                </svg>GUARDAR</b-button>
            </div>
          </b-modal>
        </div>
      </div>

      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-person-vcard display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              ETAPA DE CONTRATOS
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              DATOS GENERALES
            </p>
          </div>
        </div>
      </div>


      <div class="col-lg-12">
        <p for="" class="text-danger text-center fw-bold tamaño">
          {{ mensaje }}
        </p>
      </div>

      <div class="col-12">
        <div class="row g-2 mb-3">
          
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">NOMBRE :</p>
              <label class="ms-1 tamaño" disabled> {{ nombre }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">APELLIDO PATERNO :</p>
              <label class="ms-1 tamaño" disabled> {{ paterno }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">APELLIDO MATERNO :</p>
              <label class="ms-1 tamaño" disabled> {{ materno }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">BANCO HABERES :</p>
              <label class="ms-1 tamaño" disabled> {{ bancoHaberes }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">MONEDA HABERES :</p>
              <label class="ms-1 tamaño" disabled> {{ monHaberes }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">BANCO CTS :</p>
              <label class="ms-1 tamaño" disabled> {{ bancoCts }}</label>
            </div>
          </div>

          <div class="col-12 col-md-1">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">MONEDA CTS :</p>
              <label class="ms-1 tamaño" disabled> {{ monCts }}</label>
            </div>
          </div>

          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
              <p class="mb-0 ps-2 color">SISTEMA PENSIONES :</p>
              <label class="ms-1 tamaño" disabled> {{ sisPensiones }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="ms-2 me-2 mt-2">
        <div v-if="
          politicas1 == true &&
          politicas2 == true &&
          politicas3 == true &&
          politicas4 == true &&
          politicas5 == true &&
          politicas6 == true
        " class="row">

          <div v-for="escoge in escoger" :key="escoge.id" class="col-lg-6 col-md-6">
            <div class="shadow-lg p-3 mb-3 bg-white rounded">
              <div class="text-center text-info">
                {{ escoge.parDescripcion }}
              </div>


              <div class="d-flex">
                <div class="input-group py-1">
                  <input type="file" class="form-control tamaño" aria-describedby="inputGroupFileAddon04" multiple
                    required aria-label="Upload" @change="onFileSelected" />
                  <button class="btn btn-outline-success py-0" type="button" id="inputGroupFileAddon04"
                    @click="onUpload($event)" :value="escoge.parCorrelativo">
                    cargar
                  </button>
                </div>
                <div>
                  <button @click="ModalContrato()" v-if="escoge.parCorrelativo == '044'"
                    class="btn btn-light  ms-2  py-0">
                    <i class="bi bi-file-earmark-pdf-fill fs-5 text-danger"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
        <div class="row gx-5 gy-3">
          <!-- || permisoVisualizador == 11 permisos para descargar el contrato -->
          <!--   -->
          <div v-if="permisoVisualizador == 6"
            class="col col-12 col-sm-12 col-md-8 col-lg-5"> 

            <!-- --- -->
            <!-- <button @click="abrir" class="btn btn-danger w-100">
            <img src="../../../../assets/svg/pdf.svg" alt="" />
            <span class="ms-2">Descargar Contrato</span>
          </button> -->

             <div class="d-flex">
              <button class="btn btn-danger text-center ms-2" @click="abrir()">
                <img src="../../../../assets/svg/pdf.svg" alt="" />
              </button>
              <p class="mb-0 mt-1 align-self-center tamaño ms-3">
                GENERACIÓN DEL CONTRATO
              </p>
            </div>

              <div class="d-flex mt-2">
              <button class="btn btn-danger text-center ms-2" @click="abrirSeguro('000')">
                <img src="../../../../assets/svg/pdf.svg" alt="" />
              </button>
              <p class="mb-0 mt-1 align-self-center tamaño ms-3">
                ANEXOS
              </p>
            </div>

                <div class="d-flex mt-2">
              <button class="btn btn-danger text-center ms-2" @click="abrirSeguro('001')">
                <img src="../../../../assets/svg/pdf.svg" alt="" />
              </button>
              <p class="mb-0 mt-1 align-self-center tamaño ms-3">
                SEGURO VIDA LEY
              </p>
            </div>

                <div class="d-flex mt-2">
              <button class="btn btn-danger text-center ms-2" @click="abrirSeguro('002')">
                <img src="../../../../assets/svg/pdf.svg" alt="" />
              </button>
              <p class="mb-0 mt-1 align-self-center tamaño ms-3">
                SST
              </p>
            </div>

            <b-modal v-model="showModalContratos" size="xl" modal-class="custom-modal-body" title="Visualización PDF"
              hide-footer ok-only>
              <iframe :src="pdfUrlContratos" width="100%" height="600px"></iframe>
              
              <div class="d-flex"> 
                <!-- <b-button v-if="permisoVisualizador == 6 && validacionPdf == 0" :disabled=cambiandoEstadoContrato
                class="ms-2 mt-3" @click="ConfirmarVistaDelContrato" variant="success"><svg
                  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-save2 mx-2"
                  viewBox="0 0 16 16">
                  <path
                    d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                </svg>GUARDAR</b-button> -->

                <!-- <b-button v-if="permisoVisualizador == 6 && validacionPdf == 1" class="ms-2 mt-3"
                :disabled=cambioEstadoContratoPostulante @click="ConfirmarVistaDelContrato" variant="success"><svg
                  xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-save2 mx-2"
                  viewBox="0 0 16 16">
                  <path
                    d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                </svg>GUARDAR POSTULANTE</b-button>

              <b-button v-if="permisoVisualizador == 6 && validacionPdf == 2" class="ms-2 mt-3"
                @click="GuardarArchivoFirmado" variant="primary"><svg xmlns="http://www.w3.org/2000/svg" width="20"
                  height="20" fill="currentColor" class="bi bi-save2 mx-2" viewBox="0 0 16 16">
                  <path
                    d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                </svg>GUARDAR ARCHIVO FIRMADO</b-button> -->
               </div>
            </b-modal>
          </div> 
 <!-- hasta aqui -->
          <div v-if="permisoVisualizador == 6 || permisoVisualizador == 4" class="col-12 mx-2 mt-3">
            <!-- CASO HABILITADO -->
            <div class="card shadow-sm border-0 rounded-3 px-2 py-2 mb-3" v-if="solPosEstado == true &&
              solPosMotivo == '010' &&
              firma == false &&
              politicas1 &&
              politicas2 &&
              politicas3 &&
              politicas4 &&
              politicas5 &&
              politicas6">
              <div class="d-flex align-items-center">
                <button @click="EstadoFirma"
                  class="btn btn-warning rounded-circle d-flex justify-content-center align-items-center"
                  style="width:55px; height:55px;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                    class="bi bi-vector-pen" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-1.902 1.902-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828L10.646.646z" />
                    <path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1L2.772 13.17l.06.058z" />
                  </svg>
                </button>

                <p class="ms-3 fw-semibold text-secondary tamaño flex-grow-1">
                  1. Opción para dar conformidad de la firma de contrato
                </p>
              </div>
            </div>

            <!-- CASO DESHABILITADO -->
            <div class="d-flex align-items-center" v-else>
              <button disabled class="btn btn-success rounded-circle d-flex justify-content-center align-items-center"
                style="width:55px; height:55px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                  class="bi bi-vector-pen" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M10.646.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708L13.45 7.26l-.829 3.313a1.5 1.5 0 0 1-1.024 1.073L1.254 14.746 4.358 4.4A1.5 1.5 0 0 1 5.43 3.377l3.313-.828z" />
                  <path fill-rule="evenodd" d="M2.832 13.228 8 9a1 1 0 1 0-1-1L2.772 13.17l.06.058z" />
                </svg>
              </button>

              <p class="ms-3 fw-semibold text-secondary tamaño flex-grow-1">
                1. Opción para dar conformidad de la firma de contrato
              </p>
            </div>

            <!-- =================================== -->
            <!-- OPCIÓN 2 - MIGRACIÓN ERP            -->
            <!-- =================================== -->
            <div class="d-flex align-items-center mt-3">
          
              <button  v-if="codTrabajador == '' && solPosEstado" :disabled="firma == false" @click="insertarContrato"
                class="btn btn-warning rounded-circle d-flex justify-content-center align-items-center"
                style="width:55px; height:55px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                  class="bi bi-person-vcard" viewBox="0 0 16 16">
                  <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
                  <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2Z" />
                </svg>
              </button>

               <button v-if="spinnerCarga == true" disabled class="btn btn-success">
                <b-spinner label=""></b-spinner>
              </button>
              <button v-if="codTrabajador.length > 0" disabled class="btn btn-success">
                {{ codTrabajador }}
              </button>
              <!-- esperra la carga -->

            <!-- <button @click="CrearArchivoPersonal" class="btn btn-danger">
              Prueba de pruebas
            </button> -->

              <p class="ms-3 mt-2 tamaño">
                2. Opción para generar la migración de la información al aplicativo de Nóminas y ERP
              </p>
            </div>

            <!-- Checkbox -->
            <div  v-if="permisoVisualizador == 6 || permisoVisualizador == 4"  class="form-group d-flex align-items-end mt-2">
              <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" v-model="ingDesVinLaboral" @change="VinculoLaboral" />
                <label class="tamaño">No se presentó (Solo si se realizó el proceso de baja)</label>
              </div>
            </div>
          </div>


          <!-- negando lo anterior -->

          <div v-else class="mx-2">
            <div class="d-flex">
              <div>
                <button disabled :class="{
                  'btn btn-warning  mt-3': firma == false,
                  'btn btn-success mt-3': firma == true,
                }">
                  <img src="../../../../assets/svg/firmaOscura.svg" alt="" />
                </button>
              </div>

              <div class="mx-3 mt-4">
                <p class="tamaño">
                  1.Opción para dar conformidad de la firma de contrato
                </p>
              </div>
            </div>

            <div class="d-flex">
              
              <div v-if="codTrabajador.length <= 0">
                <button disabled class="btn btn-warning cursor">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-person-vcard" viewBox="0 0 16 16">
                    <path
                      d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8Zm1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" />
                    <path
                      d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2ZM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96c.026-.163.04-.33.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1.006 1.006 0 0 1 1 12V4Z" />
                  </svg>
                </button>
              </div>
              <div v-if="codTrabajador.length > 0">
                <button disabled class="btn btn-success">
                  {{ codTrabajador }}
                </button>
              </div>

              <div class="mt-2 mx-3">
                <p class="tamaño">
                  2.Opción para generar la migración de la información al
                  aplicativo de Nóminas y ERP
                </p>
              </div>


            </div>
          </div>
        </div>

        <div class="px-2" v-if="
          solPosEstado == true &&
          solPosMotivo == '010' &&
          permisoVisualizador != 11
        ">
          <strong class="tamaño">Los siguientes documentos son de lectura obligatoria para culminar
            con el proceso de selección:</strong>

          <div class="mt-2" v-for="(reglamento, index) in Reglamentos" :key="index.id">
            <div class="d-flex">
              <button :class="{
                'btn btn-danger   text-center':
                  Reglamentos[index][`politicas${index + 1}`],
                'btn btn-secondary align-self-center  text-center':
                  !Reglamentos[index][`politicas${index + 1}`],
              }" @click="showModales(index)">
                <img src="../../../../assets/svg/pdf.svg" alt="" />
              </button>
              <strong class="mt-1 align-self-center ms-3 tamaño">{{ index + 1 }}.</strong>

              <p class="mb-0 mt-1 align-self-center tamaño">
                {{
                  Reglamentos[index][`rutaReglamento${index + 1}`]
                    .slice(
                      48,
                      Reglamentos[index][`rutaReglamento${index + 1}`].length - 4
                    )
                    .replace(/_/g, " ")
                }}
              </p>
            </div>
          </div>


          <b-modal v-model="showModalContratosFirmar" size="xl" modal-class="custom-modal-body"
            title="Visualización PDF" hide-footer ok-only>
            <iframe :src="RutaServidorContrato + '/' + '78006764.pdf'" width="100%" height="600px"></iframe>
            <div class="d-flex">


            </div>
          </b-modal>

          <b-modal v-model="showModal" size="xl" modal-class="custom-modal-body" title="Visualización PDF" hide-footer
            ok-only>
            <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
            <div class="d-flex">
              <!-- <b-form-checkbox
            v-if="!readCheckbox"
            class="mt-4"
            v-model="readCheckbox"
          >
            <p class="mx-2">marcar aqui </p>
          </b-form-checkbox> -->
              <b-form-checkbox v-if="permisoVisualizador == 11" v-model="readCheckbox" class="mt-4">
                <p v-if="permisoVisualizador == 11" class="mx-2">
                  SI, he leído y presto mi consentimiento además de la aceptación
                  de la presente política y lo dispuesto por mi empleador.
                </p>
              </b-form-checkbox>
              <b-button v-if="permisoVisualizador == 11" class="ms-2 mt-3" :disabled="!readCheckbox"
                @click="confirmRead" variant="success"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                  fill="currentColor" class="bi bi-save2 mx-2" viewBox="0 0 16 16">
                  <path
                    d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                </svg>GUARDAR</b-button>
            </div>
          </b-modal>
        </div>

        <div v-if="permisoVisualizador != 18" class="table-responsive mx-2 mt-3">
          <div class="d-flex justify-content-end ms-4 mb-4">
            <label for="" class="mt-4 tamaño me-2"> Buscar:</label>
            <input class="form-control form-control-lg mt-3 tamañofiltrado"
              :class="{ 'w-25': !isMobile, 'w-100': isMobile }" type="text" placeholder="tipo de documento..."
              aria-label=".form-control-lg example" v-model="filterField" />
          </div>

          <table class="table table-bordered mt-3">
            <thead>
              <tr class="bg-solimano text-white text-center tamaño">
                <th>ID</th>
                <th scope="col">TIPO DOCUMENTO</th>
                <th scope="col">DOCUMENTO</th>
                <th v-if="!isMobile">RESPONSABLE DE CARGA</th>
                <th>AUDITORIA</th>

                <th v-if="permisoVisualizador == 6">ELIMINAR</th>
              </tr>
            </thead>
            <tbody v-for="(documentos, index) in documento.slice(
              NUM_RESULTS - 6,
              NUM_RESULTS
            )" :key="index.id">
              <tr class="tamaño text-nowrap align-middle">

                <td class="text-center">
                  {{ documentos.idDocumento }}</td>
                <td class="text-center">
                  <i class="bi bi-folder2-open text-warning me-1"></i>
                  {{ documentos.nomTipoDocumento }}
                </td>
                <td class="text-center">
                  <a :href="url +
                    documentos.docAdjunto.slice(
                      73,
                      documentos.docAdjunto.length
                    )
                    " target="_blank" class="btn btn-ligth">
                    <i class="bi bi-file-earmark-pdf text-danger fs-4"></i>
                  </a>
                </td>
                <td v-if="!isMobile" class="text-center">
                  <i class="bi bi-gear-wide-connected text-info me-1"></i>
                  {{ documentos.desProceso }}
                </td>
                <td class="text-center">
                  <i class="bi bi-person-badge-fill text-success me-1"></i>
                  {{ documentos.audCrea }}
                </td>

                <td v-if="permisoVisualizador == 6" class="text-center">
                  <div class="mx-2">
                    <button class="btn btn-danger" @click="Eliminar(documentos.idDocumento)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                        class="bi bi-trash3 text-white" viewBox="0 0 16 16">
                        <path
                          d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- <div v-if="permisoVisualizador != 18" class="d-flex mt-3 mb-4">
          <button class="btn btn-dark mx-4" @click="retroceso" :disabled="noRetroceder">
            <span aria-hidden="true">{{ retrocede }}</span>
          </button>
          <button class="btn btn-primary" :disabled="true">
            {{ pag }}
          </button>
          <button class="btn btn-dark mx-4" @click="aumentar" :disabled="noAvanzar">
            <span aria-hidden="true">{{ avanza }}</span>
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import swal from "sweetalert";
// import { mapGetters } from 'vuex';
export default {
  name: "SolimanologContratosPostulante",

  data() {
    return {
      isChecked: true,
      showModal: false,
      // Coloca aquí la URL de tu PDF
      pdfUrl: "",
      readCheckbox: false,
      codigoTrabajador: "",
      retrocede: "<<",
      avanza: ">>",
      filterField: "",
      RutaServidorContrato: "https://apitopas.gruposolimano.com.pe/Documentos/FirmasPostulanteContrato",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/Contratos/",
      urlContratoSinFirma:
      "https://apitopas.gruposolimano.com.pe/Documentos/1erContratoSinFirma/",
      // urlContratoSinFirma:"https://apitopas.gruposolimano.com.pe/Documentos/Contratos/",
      nombre: "",
      paterno: "",
      materno: "",
      bancoHaberes: "",
      bancoCts: "",
      monHaberes: "",
      monCts: "",
      sisPensiones: "",
      documento: [],
      escoger: [],
      noAvanzar: false,
      noRetroceder: false,
      cerrarTable1: true,
      cerrarTable2: false,
      NUM_RESULTS: 6,
      pag: 1,
      permisoVisualizador: "",
      mensaje: null,
      solPosEstado: "",
      solPosMotivo: "",
      firma: "",
      codTrabajador: "",
      spinnerCarga: false,

      form: {
        nroDocumento: "",
        tipDocumento: "",
        idEmpresa: "",
        idSolxPostulante: "",
      },
      solTipContrato: "",
      Reglamentos: [],
      empresaParametro: "",
      posicion: "",
      politicas1: "",
      politicas2: "",
      politicas3: "",
      politicas4: "",
      politicas5: "",
      politicas6: "",
      pagina: 0,
      isMobile: false,
      mostrarPdfGuardado: false,
      pdfUrlContratos: "",
      showModalContratos: false,
      validacionPdf: "",
      cambiandoEstadoContrato: false,
      cambioEstadoContratoPostulante: false,
      showModalContratosFirmar: false,
      ingDesVinLaboral: false,
      idUsuario: "",
      destinatarios:["4;6"]
    };
  },

  computed: {},

  mounted() {
    this.obtenerDatosContra();

    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.form.idEmpresa = localStorage.getItem("RqEmpresa");
    this.form.idSolxPostulante = this.$route.params.contrato;

    // politicasSST

    let autUser = localStorage.getItem("userId");
    this.idUsuario = autUser;

    this.axios
      .get(
        `Contrato/TipoDocxContrato?idSolxPostulante=${this.$route.params.contrato}&idUsuario=${autUser}`
      )
      .then((r) => {
        this.escoger = r.data;
      });

    this.axios
      .get(
        `AccessoUsuario/ObtenerCodTrabajador?idSolxPostulante=${this.$route.params.contrato}`
      )
      .then((r) => {
        console.log("el codigo del trabajador" , r.data.codTrabajador)
        if (r.data.codTrabajador != "") {
          this.buttonDiseño = false;
        }
      });

    this.checkIfMobile();
    window.addEventListener("resize", this.checkIfMobile);
  },

  created() {
    this.getAttributes();
    this.mensajeContrato();
    this.getPoliticas();
    this.obtenerDatosContra();
    this.cambiarEstadoNavbar();
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },
    obtenerDatosContra() {
      this.axios
        .get("Contrato/ObtenerDatosContrato/" + this.$route.params.contrato)
        .then((r) => {
          console.log("datos", r.data);
          this.idEmpresa = r.data[0].idEmpresa;
          this.nombre = r.data[0].posNombre;
          this.paterno = r.data[0].posApellidoPaterno;
          this.materno = r.data[0].posApellidoMaterno;
          this.bancoHaberes = r.data[0].bancoHaberes;
          this.monHaberes = r.data[0].monHaberes;
          this.bancoCts = r.data[0].bancoCts;
          this.monCts = r.data[0].monCts;
          this.sisPensiones = r.data[0].sisPensiones;
          this.solPosEstado = r.data[0].solPosEstado;
          this.solPosMotivo = r.data[0].solPosMotivo;
          this.firma = r.data[0].firma;
          this.codTrabajador = r.data[0].codTrabajador;
          this.form.nroDocumento = r.data[0].posNroDocumento;
          this.form.tipDocumento = r.data[0].posTipDocumento;
          this.solTipContrato = r.data[0].solTipContrato;
          this.politicas1 = r.data[0].politicas1;
          this.politicas2 = r.data[0].politicas2;
          this.politicas3 = r.data[0].politicas3;
          this.politicas4 = r.data[0].politicas4;
          this.politicas5 = r.data[0].politicas5;
          this.politicas6 = r.data[0].politicas6;
          this.validacionPdf = r.data[0].docValidacion;
          this.ingDesVinLaboral = r.data[0].ingDesVinLaboral
        });
    },

    VinculoLaboral() {
      console.log(this.ingDesVinLaboral)
      this.axios.get("Contrato/RegistrarAudContrato", {
        params: {
          estado: this.ingDesVinLaboral,
          idsolxPostulante: this.$route.params.contrato,
          codUsuario: localStorage.getItem('usuCodigo')
        }
      }).then(r => {
        console.log(r.data)
      })
    },

    abrir() {
      const fecha = new Date();
      const id = this.form.idSolxPostulante;
      const tipo = this.solTipContrato;
      const anio = String(fecha.getFullYear());
      const mes = String(fecha.getMonth() + 1).padStart(2, "0"); 
      console.log(this.idEmpresa)
      this.fechaGlobal = anio + mes;
      console.log(this.fechaGlobal);
      this.axios
        .get("Contrato/GenerarContratoxTipo", {
          params: {
            idSolxPostulante: id,
            tipoContrato: tipo,
              },
        })
        .then((response) => {
          console.log("Contrato generado exitosamente:", response);
          if (response.data) {
            this.showModalContratos = true;
            this.pdfUrlContratos =
              this.urlContratoSinFirma +
              `${ this.form.nroDocumento}` +
              "/" +
              this.$route.params.contrato +
              ".pdf";
            console.log(this.pdfUrlContratos);
          }
        })
        .catch((error) => {
          console.error("Error al generar contrato:", error);
        });
    
    },

    abrirSeguro(parametro){
      this.axios.get("Contrato/GenerarDocumentosComplemetarios", {
          params: {
              idSolxPostulante: this.$route.params.contrato,
              tipoComplementario: parametro // O el valor que necesites enviar
          },
          responseType: 'blob' // 👈 CRUCIAL: Esto le dice a Axios que no es JSON, sino un archivo
      })
      .then(r => {
            console.log("Datos recibidos:", r.data);

        // Si r.data es un string que dice "true", el error es 100% del Backend
        if (r.data === "true" || r.data === true) {
            alert("El servidor devolvió un booleano en lugar de un archivo. Revisa el ID enviado.");
            return;
        }

        // Aseguramos la creación del Blob correctamente
          const blob = new Blob([r.data], { type: 'application/pdf' });
          
          // Verificamos que el blob tenga contenido real
          if (blob.size < 100) {
              console.error("El archivo recibido es demasiado pequeño o está vacío");
          }

          const url = window.URL.createObjectURL(blob);
          
          const link = document.createElement('a');
          link.href = url;
          if( parametro == '001') {
            link.setAttribute('download', `SEGURO_VIDA_LEY_${this.$route.params.contrato}.pdf`);
          } else if( parametro == '002') {
            link.setAttribute('download', `SST_${this.$route.params.contrato}.pdf`);
          } else {
            link.setAttribute('download', `ANEXOS_${this.$route.params.contrato}.pdf`);
          }
          document.body.appendChild(link);
          link.click();
          
          // Limpieza
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
      })
    },
    ConfirmarVistaDelContrato() {
      if (this.validacionPdf == 0) {
        this.cambiandoEstadoContrato = true;
      }

      if (this.validacionPdf == 1) {
        this.cambioEstadoContratoPostulante = true;
      }

      this.axios
        .put(
          `Contrato/ModEstadoContratos?idSolxPostulante=${this.$route.params.contrato}&docValidacion=${this.validacionPdf}`
        )
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            this.obtenerDatosContra();
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Se guardó con éxito",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        });
    },

    GuardarArchivoFirmado() {
      const fecha = new Date();
      const id = this.form.idSolxPostulante;
      const tipo = this.solTipContrato;
      const anio = String(fecha.getFullYear());
      const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // Agrega cero si es < 10
      this.fechaGlobal = anio + mes;
      this.axios
        .get("Contrato/GenerarContratoxTipo", {
          params: {
            idSolxPostulante: id,
            tipoContrato: tipo,
            mes: mes,
            anio: anio,
            validacionPdf: this.validacionPdf,
          },
        })
        .then((response) => {
          // Puedes verificar si la respuesta es exitosa
          console.log("Contrato generado exitosamente:", response);
          if (response.data) {
            this.showModalContratos = false;
          }
        })
        .catch((error) => {
          console.error("Error al generar contrato:", error);
        });
    },

    getPoliticas() {
      this.axios
        .get(
          `Contrato/ObtenerPoliticas?idSolxPostulante=${this.$route.params.contrato}`
        )
        .then((r) => {
          console.log(r.data);
          this.Reglamentos = r.data;
        });
    },
    ModalContrato() {
      this.showModalContratosFirmar = true
      console.log("funciona 2")
    },
    showModales(index) {
      this.showModal = true;

      let ruta = `rutaReglamento${index + 1}`;
      this.pdfUrl = this.Reglamentos[index][ruta];
      this.posicion = index + 1;

      this.d = this.Reglamentos[index][`politicas${index + 1}`];
      console.log(this.d);
    },
    confirmRead() {
      console.log(this.posicion);
      // Aquí puedes realizar la acción de guardar que el PDF fue leído
      // Por ejemplo, hacer una llamada a tu API para registrar el estado de lectura
      // Luego cierra el modal
      this.axios
        .put(
          `Contrato/ModificarPolitica?idSolxPostulante=${this.form.idSolxPostulante}&posicion=${this.posicion}`
        )
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            this.showModal = false;
            this.posicion = "";
            this.obtenerDatosContra();
            this.getPoliticas();
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "SE GUARDO CON EXITO",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        });
    },

    UsuarioData() {
      this.axios
        .get("Contrato/ObtenerDatosContrato/" + this.$route.params.contrato)
        .then((r) => {
          console.log("data", r.data);

          this.nombre = r.data[0].posNombre;
          this.paterno = r.data[0].posApellidoPaterno;
          this.materno = r.data[0].posApellidoMaterno;
          this.bancoHaberes = r.data[0].bancoHaberes;
          this.monHaberes = r.data[0].monHaberes;
          this.bancoCts = r.data[0].bancoCts;
          this.monCts = r.data[0].monCts;
          this.sisPensiones = r.data[0].sisPensiones;
          this.solPosEstado = r.data[0].solPosEstado;
          this.solPosMotivo = r.data[0].solPosMotivo;
          this.firma = r.data[0].firma;
          this.codTrabajador = r.data[0].codTrabajador;
          this.soltipContrato = r.data[0].soltipContrato;
          this.form.nroDocumento = r.data[0].posNroDocumento;
          this.form.tipDocumento = r.data[0].posTipDocumento;
        });
    },
    insertarContrato() {
      console.log(this.form);
      this.spinnerCarga = true;

      this.axios.post("Contrato/ValidacionDni", this.form)
    .then((r) => {
      console.log("Respuesta validación:", r.data);

      // Si status es 1, el trabajador YA está activo en algún sistema (Apliset/Contanet)
      if (r.data.status == 1) {
        this.spinnerCarga = false;
        swal({
          title: "¡Atención!",
          text: "El colaborador ya se encuentra ACTIVO en el sistema. Debe gestionar su cese antes de reingresarlo.",
          icon: "warning",
        });

        let perfiles = "4;6";

       this.axios.get(`PuestoData/ObtenerCorreosPorPerfil?perfil=${perfiles}`).then((response) => {
          const correos = response.data.correos;
          this.destinatarios = correos; // Almacena los correos en el array de destinatarios
          console.log("Correos obtenidos:", correos);
          // Aquí puedes agregar la lógica para enviar el correo a los destinatarios obtenidos
           this.enviarCorreoPersonal()

        }).catch((error) => {
          console.error("Error al obtener correos:", error);
        });
      } 
      else {
        // Si status es 0, procedemos con la creación normal
       this.axios.post("Contrato/CodigoContanet", this.form).then((r) => {
        console.log(r.data);

        if (r.data.codContanet != "") {
          this.CrearArchivoPersonal()
          this.spinnerCarga = false;
          this.codigoTrabajador = r.data.codContanet;
          this.UsuarioData();
          this.form.idEmpresa = "";
          this.form.idSolxPostulante = "";
          this.nroDocumento = "";
          this.tipDocumento = "";
          swal("Se creo el trabajador", "", "success");
        }
      });

      this.UsuarioData();     

        }
    })
    .catch((error) => {
      console.error(error);
      swal("Error", "No se pudo completar la validación técnica", "error");
    });

     
    },

        async enviarCorreoPersonal() {
            try {

                // this.destinatarios = 'gvicente@gruposolimano.com.pe,cluyo@gruposolimano.com.pe'
                const payload = {
                    nombrePersona: this.nombre + " " + this.paterno + " " + this.materno,
                    // categoria: this.categoria,
                    destinatario: this.destinatarios  // ejemplo: "correo1@x.com,correo2@x.com"
                };

                const response = await this.axios.post(
                    "Values/CorreoPostulanteContratado",
                    null, // 🔥 SIN Body JSON, porque enviamos como querystring
                    { params: payload }
                );
                console.log(response)

            } catch (error) {
                console.error("Error:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error en el servidor",
                    text: error.message,
                });
            }
        },  

    EstadoFirma() {
      this.axios
        .put(
          `Contrato/EstadoFirmado?idSolxPostulante=${this.$route.params.contrato}`
        )
        .then((r) => {
          if (r.data) {
            this.UsuarioData();
            swal("Se realizó la firma", "", "success");
          }
        });
    },

    mensajeContrato() {
      let autUser = localStorage.getItem("userId");
      this.axios
        .get(
          `Contrato/ValidarContratos?idSolxPostulante=${this.$route.params.contrato}&idUsuario=${autUser}`
        )
        .then((r) => {
          this.mensaje = r.data;
        });
    },

    async getAttributes() {
      let doc = await this.axios.get(
        `Contrato/ListarDocContrato/${this.$route.params.contrato}`
      );
      this.documento = doc.data;
    },

    retroceder() {
      window.history.back();
    },

    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      console.log(this.selectedFile);
    },

    onUpload(event) {
      this.tipoDoc = event.target.value;
      console.log(this.tipoDoc);
      const fd = new FormData();
      fd.append("idSolxPostulante", this.$route.params.contrato);
      fd.append("tipoDoc", this.tipoDoc);
      fd.append("idUsuario", this.idUsuario);
      fd.append("ArchivoCont", this.selectedFile);

      this.axios.post("Contrato/InsertarContrato", fd).then((r) => {
        console.log(r.data);
        if (r.data == true) {
          this.mensajeContrato();
          let timerInterval;
          Swal.fire({
            title: "¡Espere un momento, no cerrar la pantalla!",
            html: "<strong>Cargando archivo <b></b> ...</strong>",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector("b");
              timerInterval = setInterval(() => {
                b.textContent = Swal.getTimerLeft();
              }, 450);
            },
            willClose: () => {
              clearInterval(timerInterval);
            },
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              this.getAttributes();

              this.extraerFirma();
            }
          });
        }
      });
    },
    extraerFirma() {
      this.axios
        .post("/CuentaData/ExtraerFirma", null, {
          params: {
            id: this.form.idSolxPostulante,
            dni: this.form.nroDocumento,
            pagina: this.pagina,
          },
        })
        .then((response) => {
          this.mensaje = response.data.mensaje;
          this.rutaFirma = response.data.rutaFirma;
          console.log("Firma extraída:", this.rutaFirma);
        })
        .catch((error) => {
          console.error("Error al extraer la firma:", error);
          this.mensaje = error.response?.data || "Ocurrió un error inesperado.";
        });
    },

    CrearArchivoPersonal() {
      this.axios
        .post("Contrato/CrearCarpetaLegajo", JSON.stringify(this.form.nroDocumento), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("Carpeta creada:", response.data);
          if (response.data.estado) {
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: "Se Creo la carpeta con exito",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        })
        .catch((error) => {
          console.error("Error al crear carpeta:", error);
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "No se pudo crear Carpeta del trabajador",
            showConfirmButton: false,
            timer: 2500,
          });
        });
    },

    Eliminar(id) {
      Swal.fire({
        title: "¿Eliminar Documento?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Eliminado!", "con exito.", "success");
          this.axios.delete("Documentos/Eliminar/" + id).then((r) => {
            console.log(r.data);
            this.getAttributes();
            this.mensajeContrato();
          });
        }
      });
    },

    retroceso() {
      if (this.NUM_RESULTS === 6) {
        // this.retro = false;
        //  this.avanzar = true;
        this.noRetroceder = true;
      } else {
        // this.retro = true;
        this.NUM_RESULTS -= 6;
        this.pag -= 1;
        this.noAvanzar = false;
        this.noRetroceder = false;
        //  this.avanzar = true
      }
    },

    aumentar() {
      this.NUM_RESULTS += 6;
      this.pag += 1;
      if (this.NUM_RESULTS > 6) {
        this.noRetroceder = false;
      } else {
        this.noRetroceder = true;
      }
      if (this.NUM_RESULTS > this.documento.length) {
        this.noAvanzar = true;
      }
      // console.log(this.NUM_RESULTS);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 0.65rem;
}

.titulo2 {
  color: #0080c8;
  text-decoration: underline;
}

.tamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #0080c8;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.tamañofiltrado {
  font-size: 0.65rem;
}
</style>
